import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Icons } from "@/assets";
import { BOTTOM_MENU, MAIN_MENU } from "@/constants/nav";



const NavItem = ({
  icon: Icon,
  label,
  path,
  isActive,
  isExpanded
}: {
  icon: any,
  label: string,
  path: string,
  isActive: boolean,
  isExpanded: boolean
}) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(path)}
      className="group flex items-center cursor-pointer h-[60px] w-full"
    >
      <div className="w-[100px] shrink-0 flex items-center justify-center">
        <div
          className={`
            w-[52px] h-[52px] rounded-full flex items-center justify-center transition-colors duration-200
            ${isActive
              ? "bg-brand"
              : "group-hover:bg-brand"
            }
          `}
        >
          <Icon
            className={`
              transition-colors duration-200
              ${isActive
                ? "text-white"
                : "text-gray-500 group-hover:text-white"
              }
            `}
          />
        </div>
      </div>

      {/* LABEL CONTAINER */}
      <div className={`overflow-hidden flex items-center h-full`}>
        <span
          className={`
            whitespace-nowrap text-lg font-medium text-gray-700 transition-all duration-300 ease-in-out transform
            ${isExpanded
              ? "opacity-100 translate-x-0"
              : "opacity-0 -translate-x-4"
            }
          `}
        >
          {label}
        </span>
      </div>
    </div>
  );
};

export const Sidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();

  return (
    <aside
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
      className={`h-[calc(100vh-86px)] border-r border-gray-20 flex flex-col items-start justify-between py-4 z-40 overflow-y-auto overflow-x-hidden
        transition-all duration-300 ease-in-out ${isExpanded ? "w-[320px] bg-white/10 backdrop-blur-md shadow-2xl" : "w-[100px] bg-white"}`}>
      {/* Top Section */}
      <div className="flex flex-col w-full">
        {MAIN_MENU.map((item, index) => (
          <NavItem
            key={index}
            icon={item.icon}
            label={item.label}
            path={item.path}
            isExpanded={isExpanded}
            isActive={location.pathname === item.path}
          />
        ))}
      </div>

      {/* Bottom Section */}
      <div className="flex flex-col w-full mb-4">
        {BOTTOM_MENU.map((item, index) => (
          <NavItem
            key={index}
            icon={item.icon}
            label={item.label}
            path={item.path}
            isExpanded={isExpanded}
            isActive={location.pathname === item.path}
          />
        ))}
      </div>
    </aside>
  );
};